import React from 'react'
import '../css/Footer.scss'

export default function Footer() {
    return (
        <footer>
            <p>Made by Adam, Alice, and Cale for HackIllinois 2022</p>
        </footer>
    )
}